import React from 'react';
import { LoginLayout } from 'layout';
import { useBuCode } from 'common/utils';
export const UnloggedScene = () => {
    const buCode = useBuCode();
    return (React.createElement(LoginLayout, { boxVisible: false, disableMainMessage: true, secondaryMessage: 'Vous avez \u00E9t\u00E9 d\u00E9connect\u00E9. Pour reprendre votre enqu\u00EAte, utilisez le lien qui vous a \u00E9t\u00E9 fourni.', buCode: buCode }));
};
